<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getParts"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-part-number" label-cols-sm="4" label-cols-lg="3" label="Part Number" label-for="filter-part-number" size="sm" :model.sync="filter.partNumber" />
					<app-input-textbox id="fieldset-part-name" label-cols-sm="4" label-cols-lg="3" label="Part Name" label-for="filter-part-name" size="sm" :model.sync="filter.partName" />
					<app-input-textarea id="fieldset-part-specification" label-cols-sm="4" label-cols-lg="3" label="Part Specification" label-for="filter-part-specification" size="sm" :model.sync="filter.partSpecificationMultiple" />
					<app-input-combobox-autocomplete :options="partReferences" optionsLabel="partNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Reference" id="filter-" size="sm" :model.sync="filter.partReferenceId" @input="getPartReferences" @focus="getPartReferences" />
					<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer" id="filter-" size="sm" :model.sync="filter.customerId" @input="getCustomers" @focus="getCustomers" />
					<b-form-group id="fieldset-is-direct-delivery" label-cols-sm="4" label-cols-lg="3" label="Direct Delivery ?" label-for="filter-is-direct-delivery">
						<b-form-checkbox id="filter-is-direct-delivery" class="float-right" v-model="filter.isDirectDelivery"></b-form-checkbox>
					</b-form-group>
					<app-input-textbox id="fieldset-stock-level-customer" label-cols-sm="4" label-cols-lg="3" label="Stock Level Customer (Day)" label-for="filter-stock-level-customer" size="sm" :model.sync="filter.stockLevelCustomer" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="partClassifications" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Classification" id="filter-" size="sm" :model.sync="filter.partClassificationId" @input="getPartClassifications" @focus="getPartClassifications" />
					<app-input-combobox-autocomplete :options="packagingTypes" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Packaging Type" id="filter-" size="sm" :model.sync="filter.packagingTypeId" @input="getPackagingTypes" @focus="getPackagingTypes" />
					<app-input-combobox-autocomplete :options="uoms" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Uom" id="filter-" size="sm" :model.sync="filter.uomId" @input="getUoms" @focus="getUoms" />
					<app-input-combobox-autocomplete :options="uomPos" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Uom Po" id="filter-" size="sm" :model.sync="filter.uomPoId" @input="getUomPos" @focus="getUomPos" />
					<app-input-textbox id="fieldset-standar-packaging-qty" label-cols-sm="4" label-cols-lg="3" label="Standard Packaging Qty" label-for="filter-standar-packaging-qty" size="sm" :model.sync="filter.standarPackagingQty" />
					<!-- <app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Vendor Subcontract" id="filter-" size="sm" :model.sync="filter.vendorSubcontractId" @input="getVendors" @focus="getVendors" /> -->
					<b-form-group id="fieldset-is-need-repacking" label-cols-sm="4" label-cols-lg="3" label="Need Repacking ?" label-for="filter-is-need-repacking">
						<b-form-checkbox id="filter-is-need-repacking" class="float-right" v-model="filter.isNeedRepacking"></b-form-checkbox>
					</b-form-group>

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getParts"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Part</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/part/Part.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<!-- <b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item> -->
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-part" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="parts" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="parts.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Part Number" class="table-filter">
					<b-form-input id="input-part-number-table" @input="getPartsWithoutLoading" v-model="filter.partNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part Name" class="table-filter">
					<b-form-input id="input-part-name-table" @input="getPartsWithoutLoading" v-model="filter.partName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part Specification" class="table-filter">
					<b-form-input id="input-part-specification-table" @input="getPartsWithoutLoading" v-model="filter.partSpecification" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part Reference" class="table-filter">
					<v-select append-to-body label="partNumber" :options="partReferences" :value="filter.partReferenceId" :reduce="item => item.id" v-model="filter.partReferenceId" :filterable="true" @input="getPartsWithoutLoading" @search="getPartReferences"></v-select>
				</b-th>
				<b-th stacked-heading="Customer" class="table-filter">
					<v-select append-to-body label="code" :options="customers" :value="filter.customerId" :reduce="item => item.id" v-model="filter.customerId" :filterable="true" @input="getPartsWithoutLoading" @search="getCustomers"></v-select>
				</b-th>
				<b-th stacked-heading="Direct Delivery ?" class="table-filter">
					<v-select append-to-body label="name" :options="yesNoCombo" :value="filter.isDirectDeliveryId" :reduce="item => item.id" v-model="filter.isDirectDelivery" :filterable="true" @input="getPartsWithoutLoading" ></v-select>
				</b-th>
				<b-th stacked-heading="Stock Level Customer (Day)" class="table-filter">
					<b-form-input id="input-stock-level-customer-table" @input="getPartsWithoutLoading" v-model="filter.stockLevelCustomer" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part Classification" class="table-filter">
					<v-select append-to-body label="code" :options="partClassifications" :value="filter.partClassificationId" :reduce="item => item.id" v-model="filter.partClassificationId" :filterable="true" @input="getPartsWithoutLoading" @search="getPartClassifications"></v-select>
				</b-th>
				<b-th stacked-heading="Packaging Type" class="table-filter">
					<v-select append-to-body label="code" :options="packagingTypes" :value="filter.packagingTypeId" :reduce="item => item.id" v-model="filter.packagingTypeId" :filterable="true" @input="getPartsWithoutLoading" @search="getPackagingTypes"></v-select>
				</b-th>
				<b-th stacked-heading="Uom" class="table-filter">
					<v-select append-to-body label="code" :options="uoms" :value="filter.uomId" :reduce="item => item.id" v-model="filter.uomId" :filterable="true" @input="getPartsWithoutLoading" @search="getUoms"></v-select>
				</b-th>
				<b-th stacked-heading="Uom Po" class="table-filter">
					<v-select append-to-body label="code" :options="uomPos" :value="filter.uomPoId" :reduce="item => item.id" v-model="filter.uomPoId" :filterable="true" @input="getPartsWithoutLoading" @search="getUomPos"></v-select>
				</b-th>
				<b-th stacked-heading="Standard Packaging Qty" class="table-filter">
					<b-form-input id="input-standar-packaging-qty-table" @input="getPartsWithoutLoading" v-model="filter.standarPackagingQty" size="sm"></b-form-input>
				</b-th>
				<!-- <b-th stacked-heading="Vendor Subcontract" class="table-filter">
					<v-select append-to-body label="code" :options="vendors" :value="filter.vendorSubcontractId" :reduce="item => item.id" v-model="filter.vendorSubcontractId" :filterable="true" @input="getPartsWithoutLoading" @search="getVendors"></v-select>
				</b-th> -->
				<b-th stacked-heading="Need Repacking ?" class="table-filter">
					<v-select append-to-body label="name" :options="yesNoCombo" :value="filter.isNeedRepackingId" :reduce="item => item.id" v-model="filter.isNeedRepacking" :filterable="true" @input="getPartsWithoutLoading" ></v-select>
				</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(partnumber)="row">
						<a @click="() => ( $router.push({ name: 'partdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.partNumber != null && row.item.partNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.partNumber.slice(0, 30) + (row.item.partNumber.length > 30 ? "..." : "" ) : row.item.partNumber : "" }}
						</a>
					</template>

				<template v-slot:cell(partspecification)="row">
					<app-long-text  :id="'partspecification-' + row.index" :text="row.item != null ? (row.item.partSpecification != null && row.item.partSpecification != '' ? row.item.partSpecification : '') : ''" />
				</template>
			<template v-slot:cell(partReference)="row">
				{{ row.item.partReference != null ? row.item.partReference.partNumber : "" }}
			</template>
			<template v-slot:cell(customer)="row">
				{{ row.item.customer != null ? row.item.customer.code : "" }}
			</template>
			<template v-slot:cell(partClassification)="row">
				{{ row.item.partClassification != null ? row.item.partClassification.code : "" }}
			</template>
			<template v-slot:cell(packagingType)="row">
				{{ row.item.packagingType != null ? row.item.packagingType.code : "" }}
			</template>
			<template v-slot:cell(uom)="row">
				{{ row.item.uom != null ? row.item.uom.code : "" }}
			</template>
			<template v-slot:cell(uomPo)="row">
				{{ row.item.uomPo != null ? row.item.uomPo.code : "" }}
			</template>
			<template v-slot:cell(vendorSubcontract)="row">
				{{ row.item.vendorSubcontract != null ? row.item.vendorSubcontract.code : "" }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textarea id="fieldset-part-specification" label-cols-lg="12"  label="Part Specification" label-for="input-part-specification" size="sm" :model.sync="row.item.partSpecification"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="partNumber" label-cols-sm="12" :model="row.item.partReferenceId" label="Part Reference" :selected="row.item.partReference != null ? row.item.partReference.partNumber : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.customerId" label="Customer" :selected="row.item.customer != null ? row.item.customer.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-checkbox id="fieldset-is-is-direct-delivery" label-cols-lg="12" label="Direct Delivery ?" label-for="input-is-is-direct-delivery" size="sm" :model.sync="row.item.isDirectDelivery" :isEditable="false" :isUpdatable="true" checkedValue="Yes" uncheckedValue="No"  />
						<app-input-textbox id="fieldset-stock-level-customer" label-cols-lg="12"  label="Stock Level Customer (Day)" label-for="input-stock-level-customer" size="sm" :model.sync="row.item.stockLevelCustomer"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.partClassificationId" label="Part Classification" :selected="row.item.partClassification != null ? row.item.partClassification.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.packagingTypeId" label="Packaging Type" :selected="row.item.packagingType != null ? row.item.packagingType.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.uomId" label="Uom" :selected="row.item.uom != null ? row.item.uom.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.uomPoId" label="Uom Po" :selected="row.item.uomPo != null ? row.item.uomPo.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-standar-packaging-qty" label-cols-lg="12"  label="Standard Packaging Qty" label-for="input-standar-packaging-qty" size="sm" :model.sync="row.item.standarPackagingQty"   :isEditable="false" :isUpdatable="true" />
						<!-- <app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.vendorSubcontractId" label="Vendor Subcontract" :selected="row.item.vendorSubcontract != null ? row.item.vendorSubcontract.code : ''" :isEditable="false" :isUpdatable="true" /> -->
						<app-input-checkbox id="fieldset-is-is-need-repacking" label-cols-lg="12" label="Need Repacking ?" label-for="input-is-is-need-repacking" size="sm" :model.sync="row.item.isNeedRepacking" :isEditable="false" :isUpdatable="true" checkedValue="Yes" uncheckedValue="No"  />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(partsPaging != null ? partsPaging.dataCount : 0)"
									:per-page="(partsPaging != null ? partsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-part.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-part.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import Part from '@/models/Part/Part';
import PartList from '@/models/Part/PartList';
import PartFilter from '@/filters/Part/PartFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import Customer from '@/models/Customer/Customer';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import PartClassificationFilter from '@/filters/PartClassification/PartClassificationFilter';
import PartClassification from '@/models/PartClassification/PartClassification';
import PackagingTypeFilter from '@/filters/PackagingType/PackagingTypeFilter';
import PackagingType from '@/models/PackagingType/PackagingType';
import UomFilter from '@/filters/Uom/UomFilter';
import Uom from '@/models/Uom/Uom';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import Vendor from '@/models/Vendor/Vendor';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		Part, 
		PartList, 
		PartFilter, 
		AppInputTextbox,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputCheckbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"partNumber": {}, "class" : "th-part-number first-child", "label" : "Part Number", key: 'partNumber', sortable: true}, 
				{"partName": {}, "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: true}, 
				{"partSpecification": {}, "class" : "th-part-specification last-child", "label" : "Part Specification", key: 'partSpecification', sortable: true}, 
				{"partReference": {}, "class" : "th-part-reference d-stack-none", "label" : "Part Reference", key: 'partReference', sortable: true}, 
				{"customer": {}, "class" : "th-customer d-stack-none", "label" : "Customer", key: 'customer', sortable: true}, 
				{"isDirectDelivery": {}, "class" : "th-is-direct-delivery d-stack-none", "label" : "Direct Delivery ?", key: 'isDirectDelivery', sortable: true}, 
				{"stockLevelCustomer": {}, "class" : "th-stock-level-customer d-stack-none", "label" : "Stock Level Customer (Day)", key: 'stockLevelCustomer', sortable: true}, 
				{"partClassification": {}, "class" : "th-part-classification d-stack-none", "label" : "Part Classification", key: 'partClassification', sortable: true}, 
				{"packagingType": {}, "class" : "th-packaging-type d-stack-none", "label" : "Packaging Type", key: 'packagingType', sortable: true}, 
				{"uom": {}, "class" : "th-uom d-stack-none", "label" : "Uom", key: 'uom', sortable: true}, 
				{"uomPo": {}, "class" : "th-uom d-stack-none", "label" : "Uom Po", key: 'uomPo', sortable: true}, 
				{"standarPackagingQty": {}, "class" : "th-standar-packaging-qty d-stack-none", "label" : "Standard Packaging Qty", key: 'standarPackagingQty', sortable: true}, 
				//{"vendorSubcontract": {}, "class" : "th-vendor-subcontract d-stack-none", "label" : "Vendor Subcontract", key: 'vendorSubcontract', sortable: true}, 
				{"isNeedRepacking": {}, "class" : "th-is-need-repacking d-stack-none", "label" : "Need Repacking ?", key: 'isNeedRepacking', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			parts: [],
			partsPaging: {},
			partReferences : [],
			customers : [],
			partClassifications : [],
			packagingTypes : [],
			uoms : [],
			uomPos : [],
			vendors : [],
			partDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	},	
	methods : {
		getParts : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			await Part.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.parts = result.data
					this.partsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getPartReferences : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			if(input == '' && this.filter.partReferenceId != null)
			{
				filter.id = this.filter.partReferenceId
			}

			await Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partReferences = result.data
					this.partsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getPartsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			await Part.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions, null, true)
			.then(result => {
				if (result != null) {
					this.parts = result.data
					this.partsPaging = result
				}
			})
			.catch(error => {});
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(input == '' && this.filter.customerId != null)
			{
				filter.id = this.filter.customerId
			}
			await Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		getPartClassifications : async function(input) {
			let filter = new PartClassificationFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(input == '' && this.filter.partClassificationId != null)
			{
				filter.id = this.filter.partClassificationId
			}
			await PartClassification.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partClassifications = result.data
				}
			})
			.catch(error => {});
		},
		getPackagingTypes : async function(input) {
			let filter = new PackagingTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(input == '' && this.filter.packagingTypeId != null)
			{
				filter.id = this.filter.packagingTypeId
			}
			await PackagingType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.packagingTypes = result.data
				}
			})
			.catch(error => {});
		},
		getUoms : async function(input) {
			let filter = new UomFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(input == '' && this.filter.uomId != null)
			{
				filter.id = this.filter.uomId
			}
			await Uom.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.uoms = result.data
				}
			})
			.catch(error => {});
		},
		getUomPos : async function(input) {
			let filter = new UomFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(input == '' && this.filter.uomPoId != null)
			{
				filter.id = this.filter.uomPoId
			}
			await Uom.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.uomPos = result.data
				}
			})
			.catch(error => {});
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new PartFilter();
			this.getParts();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getParts();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				Part.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			Part.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			Part.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			Part.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'partedit';
						if(this.isScannerMode) {
							createRoute = 'partscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			Part.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'partedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},
		deleteData(id) {
			Part.deleteData(this, id).then(result => {
				if (result)
				{
					this.getParts();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				Part.deleteMultipleData(this).then(result => {
					this.getParts();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
		scrollRight() {
			var tablePartParent = document.getElementById('table-list-part').parentNode;
			tablePartParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePartParent.scrollWidth - tablePartParent.offsetWidth) == Math.ceil(tablePartParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePartParent = document.getElementById('table-list-part').parentNode;
			tablePartParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePartParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PartFilter();
		this.getPartReferences()
		this.getCustomers()
		this.getPartClassifications()
		this.getPackagingTypes()
		this.getUoms()
		this.getVendors()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Part"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getParts();
			window.addEventListener('resize', this.onResize);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getParts();
			}
		},
		sortDesc: {
			handler: function() {
				this.getParts();
			}
		},
		currentPage: {
			handler: function() {
				this.getParts();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getParts();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				Part.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "partindex") {
					this.getPartsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "part").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
